import React, { useEffect, useState } from "react";
import { InputfieldTypes } from "../../enums/InputFieldAttributesEnums";
import styles from "./BidToolConfigurationView.module.scss";
import { ButtonShape, ButtonSize } from "../../enums/ButtonAttributesEnums";
import {
  CancelStyles,
  SubmitStyles,
  BidConfigFormProps,
  constantValues,
  stepTwoKeys,
  fieldNames,
  DOLLAR_PREFIX,
  bidToolResetModalConstants,
} from "./constants";
import InputField from "../../reusable-components/TNInputField";
import { Col, Modal, notification, Row } from "antd";
import TNButton from "../../reusable-components/TNButton";
import { BidToolSettingsConfig } from "../../types/getSettingsBidConfigDataObject";
import { useFormContext } from "react-hook-form";
import { BidConfigPayloadFormatter } from "../../utils/bidConfigPayloadFormatter";
import { stripCurrencyFormatting } from "../../Utilities/regex";
import BidToolConfigServices from "../../services/bidToolConfig.service";
const BidCalculatorInputs: React.FC<TruckAssumptionsContentProps> = ({
  initialValues,
  handleSaveOption,
  handleValidationErrors,
}) => {
  const {
    watch,
    setValue,
    trigger,
    clearErrors,
    handleSubmit,
    formState: { isValid },
  } = useFormContext();
  const { SUBMIT_BTN_TXT, CANCEL_BTN_TXT, ROW_ALIGN } = BidConfigFormProps;
  const containerFields = initialValues?.data?.[0]?.bidCalculationInputs;
  const currentFieldValues = watch();
  const payloadData = BidConfigPayloadFormatter({
    payloadData: currentFieldValues,
    id: initialValues?.data?.[0]?.id,
  });
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);
  const handleOpenWarningModal = () => setIsWarningModalOpen(true);
  const handleCloseWarningModal = () => setIsWarningModalOpen(false);
  const { SubmitSettingsBidConfig } = BidToolConfigServices();
  const { mutateAsync: stepTwoSubmitMutate } = SubmitSettingsBidConfig();
  const handleStepTwoSubmit = async () => {
    await stepTwoSubmitMutate(payloadData, {
      onSuccess: () => {
        setIsSuccessOpen(true);
      },
    });
  };
  const handleTexasDieselRedirection = () => {
    window.open("https://gasprices.aaa.com/?state=TX", "_blank");
  };
  const handleBlur =
    (fieldName: string) => (event: React.FocusEvent<HTMLInputElement>) => {
      const value = parseFloat(stripCurrencyFormatting(event.target.value));
      if (!isNaN(value)) {
        const roundedValue = value.toFixed(2);
        setValue(fieldName, roundedValue);
      }
      trigger(fieldName);
    };
  const resetStepValues = () => {
    setValue(
      fieldNames.TEXAS_DIESEL_AVG_CONFIG,
      containerFields?.[0]?.texasDieselAvg
    );
    setValue(
      fieldNames.TRUCK_MPG_AVG_CONFIG,
      containerFields?.[0]?.truckMPGAvg
    );
  };
  useEffect(() => {
    if (isSuccessOpen) {
      handleSaveOption(isSuccessOpen);
      setIsSuccessOpen(false);
    }
  }, [isSuccessOpen]);
  return (
    <>
      <Modal
        visible={isWarningModalOpen}
        onCancel={handleCloseWarningModal}
        title={bidToolResetModalConstants.TITLE_TEXT}
        okText={bidToolResetModalConstants.CONFIRM_TEXT}
        onOk={() => {
          resetStepValues();
          clearErrors(stepTwoKeys);
          notification.success({
            message: bidToolResetModalConstants.SUCCESS_MESSAGE,
          });
          handleCloseWarningModal();
        }}
      >
        <p style={bidToolResetModalConstants.MODAL_MESSAGE_STYLE}>
          {bidToolResetModalConstants.CONFIRM_MESSAGE}
        </p>
      </Modal>
      <div className={styles.TruckAssumptionWrapper}>
        <div className={styles.BidContentContainer}>
          <Row>
            <Col span={20}>
              <div className={styles.outerWrapper}>
                <Row align={ROW_ALIGN} className={styles.RowInputContainer}>
                  <Col span={10}>
                    <div
                      onClick={handleTexasDieselRedirection}
                      className={styles.TexasDieselText}
                    >
                      Texas Diesel Avg
                    </div>
                  </Col>
                  <Col span={14}>
                    <div className={styles.alignMinContainer}>
                      <InputField
                        customSmallErrorText
                        formattedNumberType
                        fixedDecimalScale={true}
                        name={fieldNames.TEXAS_DIESEL_AVG_CONFIG}
                        type={InputfieldTypes.TEXT}
                        prefix={DOLLAR_PREFIX}
                        onBlur={handleBlur(fieldNames.TEXAS_DIESEL_AVG_CONFIG)}
                      />
                      <span className={styles.alignUnit}>&nbsp;&nbsp;gal</span>
                    </div>
                  </Col>
                </Row>
                <Row align={ROW_ALIGN} className={styles.RowInputContainer}>
                  <Col span={10}>
                    <div>Truck MPG Avg</div>
                  </Col>
                  <Col span={14}>
                    <div className={styles.alignMinContainer}>
                      <InputField
                        customSmallErrorText
                        formattedNumberType
                        fixedDecimalScale={true}
                        name={fieldNames.TRUCK_MPG_AVG_CONFIG}
                        type={InputfieldTypes.TEXT}
                        onBlur={handleBlur(fieldNames.TRUCK_MPG_AVG_CONFIG)}
                      />
                      <span className={styles.alignUnit}>&nbsp;&nbsp;mpg</span>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          <Row className={styles.ButtonRow}>
            <Col span={24}>
              <div className={styles.buttonWrapper}>
                <TNButton
                  shape={ButtonShape.DEFAULT}
                  size={ButtonSize.LARGE}
                  text={CANCEL_BTN_TXT}
                  customStyles={CancelStyles}
                  onClick={handleOpenWarningModal}
                />
                <TNButton
                  shape={ButtonShape.DEFAULT}
                  size={ButtonSize.LARGE}
                  text={SUBMIT_BTN_TXT}
                  customStyles={SubmitStyles}
                  onClick={handleSubmit(
                    handleStepTwoSubmit,
                    handleValidationErrors
                  )}
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
export default BidCalculatorInputs;
